<template>
  <div>
    <div class="row">
      <div
        v-for="game in showingItem"
        :key="game.code"
        class="col-xs-6 col-sm-4 col-md-3"
      >
        <div class="panel">
          <div class="panel-header">
            <center>
              <img
                :src="game.preview"
                width="100%"
                style="cursor: pointer;"
                @click="luanchGame(game.playUrl)"
              >
            </center>
          </div>
          <div class="panel-footer">
            <button
              class="btn btn-primary btn-block"
              @click="luanchGame(game.playUrl)"
            >
              เล่นเกมนี้
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- <ul class="pagination">
      <li
        v-for="(pageIndex, index) in totalPages"
        :key="index"
        :class="page === pageIndex ? 'active' : ''"
      >
        <a @click="page = pageIndex">{{ pageIndex }}</a>
      </li>
    </ul> -->
  </div>
</template>

<script>
import nagaGamesApi from '../api/nagaGames';

export default {
  name: 'NagaGameList',
  data:() => ({
    games: [],
    page: 1,
    itemPerPage: 40,
    totalItem: 0,
    showingItem: [],
    lunchingOn: '',
    loading: false,
  }),
  methods: {
    paginate() {
      const startedIndex = (this.page - 1) * this.itemPerPage;
      const endIndex = this.page * this.itemPerPage;
      this.showingItem = this.games.slice(startedIndex, endIndex)
    },
    loadData() {
      nagaGamesApi.getGames(({ data }) => {
        console.log('data', data);
        this.games = [ ...data.games ];
        this.totalItem = this.games.length;
        this.paginate();
      });
    },
    async luanchGame(playUrl) {
      await nagaGamesApi.luanchGame((response) => {
        window.location.href = response.data.gameUrl;
      }, {
        gameUrl: playUrl
      });
      const isMobile = this.detectMoblie();
      this.loading = true;
      
    },
    detectMoblie() {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
      ];
      return toMatch.some((toMatchItem) => {
          return navigator.userAgent.match(toMatchItem);
      });
    },
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItem / this.itemPerPage);
    }
  },
  watch: {
    page() {
      this.paginate();
    },
  },
  mounted() {
    this.loadData();
  },
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/admin/components/NagaGameList.vue